var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewsSliderSitejabberStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.072,
    cy: 10,
    fill: "#EE6A22",
    rx: 10.072,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m10.072 13.158-1.947 1.016a1 1 0 0 1-1.448-1.057l.37-2.141-1.56-1.51a1 1 0 0 1 .552-1.709l2.163-.312.974-1.96a1 1 0 0 1 1.791 0l.974 1.96 2.163.312a1 1 0 0 1 .553 1.709l-1.56 1.51.37 2.141a1 1 0 0 1-1.449 1.057l-1.946-1.016Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.734)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.072,
    cy: 10,
    fill: "#EE6A22",
    rx: 10.072,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m10.072 13.158-1.947 1.016a1 1 0 0 1-1.448-1.057l.37-2.141-1.56-1.51a1 1 0 0 1 .552-1.709l2.163-.312.974-1.96a1 1 0 0 1 1.791 0l.974 1.96 2.163.312a1 1 0 0 1 .553 1.709l-1.56 1.51.37 2.141a1 1 0 0 1-1.449 1.057l-1.946-1.016Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.467)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.072,
    cy: 10,
    fill: "#EE6A22",
    rx: 10.072,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m10.072 13.158-1.947 1.016a1 1 0 0 1-1.448-1.057l.37-2.141-1.56-1.51a1 1 0 0 1 .552-1.709l2.163-.312.974-1.96a1 1 0 0 1 1.791 0l.974 1.96 2.163.312a1 1 0 0 1 .553 1.709l-1.56 1.51.37 2.141a1 1 0 0 1-1.449 1.057l-1.946-1.016Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.072,
    cy: 10,
    fill: "#EE6A22",
    rx: 10.072,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m10.072 13.158-1.947 1.016a1 1 0 0 1-1.448-1.057l.37-2.141-1.56-1.51a1 1 0 0 1 .552-1.709l2.163-.312.974-1.96a1 1 0 0 1 1.791 0l.974 1.96 2.163.312a1 1 0 0 1 .553 1.709l-1.56 1.51.37 2.141a1 1 0 0 1-1.449 1.057l-1.946-1.016Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.935)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.072,
    cy: 10,
    fill: "#EE6A22",
    rx: 10.072,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m10.072 13.158-1.947 1.016a1 1 0 0 1-1.448-1.057l.37-2.141-1.56-1.51a1 1 0 0 1 .552-1.709l2.163-.312.974-1.96a1 1 0 0 1 1.791 0l.974 1.96 2.163.312a1 1 0 0 1 .553 1.709l-1.56 1.51.37 2.141a1 1 0 0 1-1.449 1.057l-1.946-1.016Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewsSliderSitejabberStars);
export default __webpack_public_path__ + "static/media/reviews-slider-sitejabber-stars.393c0016caaf6e21f106ef7b60c9e475.svg";
export { ForwardRef as ReactComponent };